import React, { Component } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { TableListComp, DeletePopUp, EmptyCollection, PageLoader } from '../../../../shared_elements';
import { QfdMntEventList, QfdMntEventCRU } from '../components';
import { Header, EditSidebar, ContractHeadertext, CtrTableHd, ContractSideBar, FormModeType } from '../../../../applications/contracts/Elements';
import { ContractWrapper, LeaseDetialTab } from '../../../Elements';
import { STableLoader } from '../../../../shared_elements/loaders';
import { getReserveAccountsAc, sExportContractsAc } from '../../../actionCreators';
import { getQfdMntEventsListApi,deleteQfdMntEventsApi } from '../apiServices';
import { qfdMntEventHd } from '../';
import { assetsType } from '../../../../constants';
import { trackActivity } from '../../../../utils_v2/mixpanel';
import { getLocalStorageInfo, checkPermission } from '../../../../utils_v2';
import {contrHdlineInfoAc } from '../../../../applications/contracts/HeadlinesInfo/actionCreators'
import RoleBasedAccess from '../../../../utils/RoleBasedAccess'
class QfdMntEvents extends Component {
  constructor(props){
    super(props);
    this.state = {
      skeletonLoader: true,
      pageLoader: false,
      list:[],
      deleteItem:{modal:false, data:null}
    }
    this.getQfdMntEventsListApi = getQfdMntEventsListApi.bind(this);
    this.deleteQfdMntEventsApi = deleteQfdMntEventsApi.bind(this);
  }
  componentDidMount(){
    this.getQfdMntEventsListApi(this.props);
    this.props.getReserveAccounts();
    this.props.fetchContractInfo();
    trackActivity('Lease Management', {
      page_title: 'Qualified Maintenance Events',
      event_type: 'Page Visited'
    })
  }
  getResponseBack = () => {
    this.getQfdMntEventsListApi(this.props);
  }
  changeMsn =(evt) =>{
    let url = '/'+assetsType[evt.asset_type]+'/'+evt.slug+'/contracts';
    browserHistory.push(url);
    this.props.params.type = assetsType[evt.asset_type];
    this.props.params.aircraft_slug = evt.slug;
  }
  render(){
    const { list, qfdMntEvent, deleteItem,  skeletonLoader, pageLoader } = this.state;
    const { reserveAccounts, params, contractSummaryLoader, contractInfo } = this.props;
    return(
      <div className="contract-container">
        <Header type="brief" headingText="Lease Management" params= {this.props.params} changeMsn={this.changeMsn} exportContract={this.props.exportContract} />
        <ContractSideBar application="Qualified Maintenance Events" type="brief" params={this.props.params} />
        <div className="contract-content-blk">
          <LeaseDetialTab url='qualified-maintenance' primaryTab='technical-details' secondaryTab='qfdMntEvents' />
          <ContractWrapper
            revision={true}
            url='audit/contracts/ctqualifiedmaintenanceevents/'
            queryParams={{action:0, contract:this.props.params.contract_slug}}
            params={params}
            buttonText={ checkPermission('contracts','qualified_maintenance_event', 'C') ?<QfdMntEventCRU contractInfo={contractInfo} reserveAccounts={reserveAccounts} getResponseBack={this.getResponseBack} />:null}
          >
            { skeletonLoader ?
              (<STableLoader count={8} />):
              (
                <TableListComp
                  heads={qfdMntEventHd}
                  data={list.map((item,index) =>
                    <QfdMntEventList
                      key={index}
                      contractInfo={contractInfo}
                      getResponseBack={this.getResponseBack}
                      reserveAccounts={reserveAccounts}
                      item={item} 
                      deleteQfdMntEvents={() => this.setState({deleteItem:{modal:true, data:item}})}/>
                    )
                  }
                  noRecord={ list.length ? null:
                    <EmptyCollection
                      title="No records found"
                    />
                  }
                />
              )
            }
            { pageLoader || contractSummaryLoader ? <PageLoader />:null}
          </ContractWrapper>
        </div>
        { deleteItem.modal?
          <DeletePopUp
            modal={deleteItem.modal}
            toggleModalFn={() => this.setState({deleteItem:{modal:false, data:null}})}
            title="Delete"
            content={<h4>Are you sure you want to delete?</h4>}
            deleteRecordFn={() => this.deleteQfdMntEventsApi(this.props,deleteItem)}
          />:null
        }
      </div>
    )
  }
}
const mapStateToProps = state => ({
  reserveAccounts: state.contractReducer.reserveAccounts,
  contractSummaryLoader: state.contractReducer.contractSummaryLoader,
  contractInfo: state.ContrHdlineReducer.contrHdlineInfo,
})
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchContractInfo: () => dispatch(contrHdlineInfoAc(ownProps.params)),
    getReserveAccounts: () => dispatch(getReserveAccountsAc(ownProps)),
    exportContract : (contract_slug) => dispatch(sExportContractsAc(contract_slug))
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RoleBasedAccess(QfdMntEvents,['contracts','qualified_maintenance_event', 'R'])))
